import type { SVGProps } from 'react';
const DawnFlagAR = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect
      width={21.5}
      height={15.5}
      x={0.25}
      y={0.25}
      fill="#fff"
      stroke="#F5F5F5"
      strokeWidth={0.5}
      rx={1.75}
    />
    <mask
      id="dawn-flag-AR_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g mask="url(#dawn-flag-AR_svg__a)">
      <path
        fill="#88BBE8"
        fillRule="evenodd"
        d="M0 5.333h22V0H0zM0 16h22v-5.333H0z"
        clipRule="evenodd"
      />
      <path
        fill="#F4B32E"
        stroke="#DB7A2C"
        strokeWidth={0.667}
        d="M11 9.933c1.058 0 1.905-.871 1.905-1.933S12.058 6.067 11 6.067c-1.057 0-1.905.87-1.905 1.933 0 1.062.848 1.933 1.905 1.933Z"
      />
    </g>
  </svg>
);
export default DawnFlagAR;
